<template>
  <gradient-background>
    <center-card>
      <template v-slot:card-title>
        {{$t('resetPassword.title')}}
      </template>
      <template v-slot:card-body>
        <reset-password-form
          :user-id="userId"
          :reset-code="resetCode"
        />
      </template>
    </center-card>
  </gradient-background>
</template>

<script>
  import GradientBackground from '../layouts/general/GradientBackground.vue';
  import CenterCard from '../layouts/cards/CenterCard.vue';
  import ResetPasswordForm from '../components/auth/ResetPasswordForm.vue';

  export default {
    components: {
      GradientBackground,
      CenterCard,
      ResetPasswordForm,
    },
    data() {
      return {
        userId: this.$route.params.userId,
        resetCode: this.$route.params.resetCode,
      };
    },
  };
</script>
